import i18n from 'src/i18n';

// Help Scout Beacon does not auto-translate from a locale param: you localize
// by passing a `labels` object. English is Beacon's built-in default, so we only
// need to supply overrides for the other supported locale(s).
// Full label reference: https://developer.helpscout.com/beacon-2/web/javascript-api/#config
const LABELS = {
  nl: {
    wantToAskQuestion: 'Een vraag stellen?',
    chatHeadingTitle: 'Hoe kunnen we helpen?',
    askHeading: 'Stuur ons een bericht',
    askSubheading: 'We reageren zo snel mogelijk',
    askPlaceholder: 'Hoe kunnen we je helpen?',
    askFileUpload: 'Voeg een bestand toe',
    askMessageButtonLabel: 'Bericht versturen',
    askMessageButtonProcessingLabel: 'Bezig met versturen…',
    messageConfirmationText: 'Bericht ontvangen!',
    messageConfirmationSubtext: 'We nemen snel contact met je op.',
    answersHeading: 'Antwoorden vinden',
    searchLabel: 'Waar kunnen we je mee helpen?',
    suggestedForYou: 'Voor jou aanbevolen',
    noResults: 'Geen resultaten gevonden',
    nameLabel: 'Naam',
    emailLabel: 'E-mailadres',
    subjectLabel: 'Onderwerp',
    messageLabel: 'Bericht',
    sendAMessage: 'Stuur een bericht',
    previousMessages: 'Eerdere berichten',
    receivedMessage: 'Je hebt een bericht ontvangen',
    history: 'Geschiedenis',
    cancel: 'Annuleren',
  },
};

function normalizeLocale(locale) {
  return (locale || '').toString().toLowerCase().split(/[-_]/)[0];
}

/**
 * Localize the Beacon widget to the user's language.
 * English (Beacon default) needs no labels; other locales get an overrides map.
 */
export function setBeaconLanguage(locale) {
  if (!window.Beacon) return;
  const lang = normalizeLocale(locale) || normalizeLocale(i18n.locale);
  const labels = LABELS[lang];
  if (labels) {
    window.Beacon('config', { labels });
  }
}

/**
 * Identify the logged-in user to Beacon (tenant + email) and set the language.
 * `profile` is the `/you` response payload (UserService.getProfile().data).
 */
export function identifyBeacon(profile = {}) {
  if (!window.Beacon) return;

  const user = profile.user || {};
  const tenant = profile.client && profile.client.name;

  setBeaconLanguage(user.locale);

  window.Beacon('identify', {
    email: user.email,
    name: [user.given_name, user.family_name].filter(Boolean).join(' ') || undefined,
    tenant,
  });
}

export function logoutBeacon() {
  if (window.Beacon) {
    window.Beacon('logout');
  }
}
